/** @flow */

const demo_prospetto = {
  costo_iva_inc: 1100,
  costo_iva_esc: 1000,
  anni_finanziamento: {
    "5": {
      importo_mensile: 18.3
    },
    "4": {
      importo_mensile: 22.9
    },
    "3": {
      importo_mensile: 30.5
    },
    "2": {
      importo_mensile: 45.8
    },
    "1": {
      importo_mensile: 91.5
    }
  }
};

export default {
  demo_prospetto
};
